<template>
  <div class="group-customer">
    <div class="group-customer-top">
      <div class="classification">
        <!-- <span :class="active==1?'active':''" @click="btnClick(1)">账户信息</span>
        <span>|</span> -->
        <span :class="active==1?'active':''" @click="btnClick(1)">客户列表</span>
        <span>|</span>
        <span :class="active==2?'active':''" @click="btnClick(2)">订单列表</span>
        <span>|</span>
        <span :class="active==3?'active':''" @click="btnClick(3)">扣费记录</span>
        <span>|</span>
        <span :class="active==4?'active':''" @click="btnClick(4)">充值记录</span>
        <!-- <span>|</span>
        <span :class="active==6?'active':''" @click="btnClick(6)">车辆</span> -->
      </div>
    </div>
    <div class="group-customer-bottom">
      <!-- <div v-if="active==1">
        <account-information></account-information>
      </div> -->
      <div v-if="active==1">
        <customer-list></customer-list>
      </div>
      <div v-if="active==2">
        <order-list></order-list>
      </div>
      <div v-if="active==3">
        <deduction-record></deduction-record>
      </div>
      <div v-if="active==4">
        <recharge-record></recharge-record>
      </div>
      <!-- <div v-if="active==6">
        <vehicle></vehicle>
      </div> -->
    </div>
  </div>
</template>

<script>
import CustomerList from "./customerList.vue";
import OrderList from "./orderList.vue";
import DeductionRecord from "./deductionRecord.vue";
import RechargeRecord from "./rechargeRecord.vue";
import AccountInformation from "./accountInformation.vue";
import Vehicle from "./vehicle.vue";
export default {
  data() {
    return {
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      active:1,
    };
  },
  mounted() {
    this.$nextTick(function() {
      
    });
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    btnClick(num){
      this.active = num;
    },
  },
  components: {
    CustomerList,
    OrderList,
    DeductionRecord,
    RechargeRecord,
    AccountInformation,
    Vehicle,
  },
};
</script>

<style scoped lang="scss">
.group-customer {
  .group-customer-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    .classification {
      display: inline-block;
      line-height: 60px;
      margin-left: 1%;
      span {
        margin-right: 20px;
        color: #999999;
        font-size: 16px;
        cursor: pointer;
      }
      span.active {
        color: #0177BD;
        font-weight: 600;
      }
    }
  }
  .group-customer-bottom {
    width: 98%;
    background-color: #ffffff;
    // padding:20px 0;
    margin-left: 1%;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/membershipManagement/groupCustomer.vue